import { Auth0Provider } from '@auth0/auth0-react';
import { DialogProvider, ToastProvider } from '@rocketmakers/armstrong';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ApiHooksStore } from '../../shared/api-clients/store';
import { BeeProvider } from '../../shared/context/bee';
import '../../shared/theme/theme.scss';
import { BeeConfigProvider } from './hooks/beeConfig';
import { ZonesProvider } from './hooks/zones';
import { Routes } from './routes';

Sentry.init({
  dsn: 'https://d84619105fd34d629d2fa7ca991aa51c@o530025.ingest.sentry.io/6323723',
  integrations: [new BrowserTracing()],
  environment: APP_CONFIG.environment,

  tracesSampleRate: 0.1,
});

async function render() {
  ReactDOM.render(
    <BrowserRouter>
      <Auth0Provider
        domain={APP_CONFIG.auth0Domain}
        clientId={APP_CONFIG.auth0ClientId}
        redirectUri={APP_CONFIG.appBaseUrl}
        audience={APP_CONFIG.auth0Audience}
      >
        <ApiHooksStore.Provider>
          <ToastProvider>
            <DialogProvider>
              <BeeProvider>
                <BeeConfigProvider>
                  <ZonesProvider>
                    <Routes />
                  </ZonesProvider>
                </BeeConfigProvider>
              </BeeProvider>
            </DialogProvider>
          </ToastProvider>
        </ApiHooksStore.Provider>
      </Auth0Provider>
    </BrowserRouter>,
    document.getElementById('host')
  );
}

render();
